const isValidFieldId = (value: string) => {
  if (!value) return false;
  return /^[a-z0-9_-]+$/.test(value);
};

const getFieldIdError = (value: string, options: { validateEmpty?: boolean } = {}): string | undefined => {
  const { validateEmpty = false } = options;
  
  if (!value) {
    return validateEmpty ? "Field ID cannot be empty" : undefined;
  }
  
  if (!isValidFieldId(value)) {
    return "Use only lowercase letters, numbers, underscores and hyphens";
  }
  
  return undefined;
};

export const validate = {
  isValidFieldId,
  getFieldIdError,
};
